export default __webpack_public_path__ + "static/char-sp03-0c729d56aee9fd143597c52abf986ddb.gif";